import { useEffect } from 'react'

import DrawerHeader from '@components/DrawerHeader/DrawerHeader'
import { CircularProgress, Divider, Stack } from '@mui/material'
import { useFormContext, UseFormReturn, useWatch } from 'react-hook-form'

import ExcludeSimilar from './ExcludeSimilar'
import MainSettings from './MainSettings'
import RequireReview from './RequireReview'

type Props = {
	mode: 'NEW' | 'EDIT'
	loading: boolean
	formId: string
	onClose: () => void
	parentForm?: UseFormReturn<any>
}

/**
 * Basket settings form
 */
export default function BasketSettingsForm({
	loading,
	onClose,
	mode,
	formId,
	parentForm = null,
}: Props) {
	const {
		setValue,
		formState: { dirtyFields },
	} = useFormContext()

	const tier = useWatch({ name: 'tier' })

	useEffect(() => {
		if (tier !== 'Customer Tier' && mode === 'EDIT') {
			setValue('ignoreCustomersWithInvalidTiers', false, {
				shouldDirty: true,
				shouldValidate: true,
			})
		}
	}, [setValue, tier, mode])

	return (
		<Stack spacing={2} sx={{ width: '48.125rem', p: 2 }}>
			<DrawerHeader
				label="Settings"
				dirty={!!Object.keys(dirtyFields).length}
				onCancel={onClose}
				submit
				formId={formId}
			/>

			{loading && <Loader />}
			{!loading && (
				<>
					<MainSettings mode={mode} parentForm={parentForm} />

					<ExcludeSimilar />

					<RequireReview parentForm={parentForm} />
				</>
			)}
		</Stack>
	)
}

function Loader() {
	return (
		<Stack
			spacing={2}
			sx={{ height: '10rem', width: '100%', p: 2, justifyContent: 'center', alignItems: 'center' }}
		>
			<CircularProgress color="secondary" />
		</Stack>
	)
}
